
import { Vue } from "vue-class-component";
import { useStore } from "vuex";
import StorageService from "../services/StorageService";
import ApiService from "../services/ApiService";
import { wrapper } from "../utils/wrapper";

export default class ChangePasswordForm extends Vue {
  private storageService = new StorageService();
  private apiService = new ApiService();
  globalStore = useStore();
  changePasswordButtonEnabled = true;
  newPassword = "";
  confirmPassword = "";

  invalidPasswords() {
    if (!this.newPassword || !this.confirmPassword) return true;
    if (this.newPassword === this.confirmPassword) return false;
    return true;
  }

  async resetPassword() {
    this.changePasswordButtonEnabled = false;
    const user = this.storageService.getUser();
    const id = user.patientsId;
    const resetResponse = await wrapper(
      this.apiService.reset(id, this.newPassword)
    );
    if (resetResponse.error) {
      this.changePasswordButtonEnabled = true;
      if (resetResponse.error.status === 400) {
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.PASSWORD.INVALID.TITLE"),
          text: this.$t("ALERTS.PASSWORD.INVALID.TEXT")
        });
        this.newPassword = "";
        this.confirmPassword = "";
      } else {
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.PASSWORD.FAILED.TITLE"),
          text: this.$t("ALERTS.PASSWORD.FAILED.TEXT")
        });
        this.newPassword = "";
        this.confirmPassword = "";
      }
    }
    if (resetResponse.data) {
      this.globalStore.commit("open", {
        type: "success",
        title: this.$t("ALERTS.PASSWORD.SUCCESS.TITLE"),
        text: this.$t("ALERTS.PASSWORD.SUCCESS.TEXT")
      });
      await this.$router.push("home");
    }
  }
}
